import React from 'react';
import { YMInitializer } from 'react-yandex-metrika';

export const YaMetrics = () => (
  <>
    {process.env.REACT_APP_ENV === 'prod' && (
      <YMInitializer accounts={[75076087]} options={{ webvisor: true }} version='2' />
    )}
  </>
);
